import Icon from "./Icon";
import { NAMES, SIZES } from "./utilities";

export { NAMES, SIZES };
export default Icon;
